const hideScrollbars = {
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
    '&::-webkit-scrollbar': {
        display: 'none',
    },
};

export { hideScrollbars };
